interface SuccessNotificationProps {
  message: string;
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({ message }) => {
  return (
    <div
      role="alert"
      className="el-notification right"
      style={{ top: 16, zIndex: 2011 }}
    >
      <i className="el-notification__icon el-icon-success"></i>
      <div className="el-notification__group is-with-icon">
        <div className="el-notification__content">
          <p>{message}</p>
        </div>
        <div className="el-notification__closeBtn el-icon-close"></div>
      </div>
    </div>
  );
};

export default SuccessNotification;